<template>
    <DCard
        padding
    >
        <DTable
            :items="rules"
            :fields="[
                {key: 'id', label: __('products.termination_rules.id')},
                {key: 'name', label: __('products.termination_rules.name')},
                {key: 'notification', label: __('products.termination_rules.notification')},
                {key: 'suspension', label: __('products.termination_rules.suspension')},
                {key: 'auto_renew', label: __('products.termination_rules.auto_renew')},
                {key: 'deletion', label: __('products.termination_rules.deletion')},
                {key: 'default', label: __('products.termination_rules.default')},
                {key: 'actions', label: '', sorter: false, filter: false},
            ]"
            hover
            sorter
        >
            <template #notification="{item}">
                <td>
                    {{ item.notification !== null ? item.notification + 'd' : '-' }}
                </td>
            </template>
            <template #suspension="{item}">
                <td>
                    {{ item.suspension !== null ? item.suspension + 'd' : '-' }}
                </td>
            </template>
            <template #auto_renew="{item}">
                <td>
                    {{ item.auto_renew !== null ? item.auto_renew + 'd' : '-' }}
                </td>
            </template>
            <template #deletion="{item}">
                <td>
                    {{ item.deletion + 'd' }}
                </td>
            </template>
            <template #default="{item}">
                <td>
                    {{ item.default ? __('customers.common.yes') : '' }}
                </td>
            </template>

            <template #actions="{item}">
                <td>
                    <div
                        v-if="userPermissions.includes('product.termination_rules.edit')"
                        class="actions"
                    >
                        <DButton
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            @click="editTerminationRule(item.id)"
                        />
                        <DButton
                            :id="`make-default-${item.id}`"
                            mini
                            icon="check-circle-outline"
                            :label="__('messages.actions.makeDefault')"
                            :disabled="item.default"
                            @click="makeDefaultTerminationRule(item.id)"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            icon="trash-can-outline"
                            color="danger"
                            @click="destroyTerminationRule(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                v-if="userPermissions.includes('product.termination_rules.edit')"
                id="btn-add"
                icon="plus"
                :label="__('products.termination_rules.add')"
                @click="openCreatePage"
            />
        </DFabs>
        <DModal
            v-model:show="showConfirmationModal"
            :title="__('products.termination_rules.deleteConfirmation.title')"
            :message="__('products.termination_rules.deleteConfirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { router, usePage } from '@inertiajs/vue3'
import { computed, ref } from 'vue'

defineProps({
    rules: {
        type: Array,
        default: () => { return [] }
    }
})

const userPermissions = computed(() => usePage().props.auth.permissions)
const showConfirmationModal = ref(false)
let deleteCallBack = () => { return {} }

function makeDefaultTerminationRule (id) {
    router.post(route('products.termination-rules.make-default', id))
}

function destroyTerminationRule (id) {
    deleteCallBack = () => {
        router.delete(route('products.termination-rules.destroy', id))
        showConfirmationModal.value = false
    }
    showConfirmationModal.value = true
}

function editTerminationRule (id) {
    router.get(route('products.termination-rules.edit', id))
}

function openCreatePage () {
    router.get(route('products.termination-rules.create'))
}
</script>

<style lang="scss" scoped>
.actions {
    display: flex;
    grid-gap: 10px;
    justify-content: flex-end;
}
</style>
